import { render, staticRenderFns } from "./profile-edit-password.vue?vue&type=template&id=493d5a3d"
import script from "./profile-edit-password.vue?vue&type=script&lang=js"
export * from "./profile-edit-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports